module.exports = __webpack_public_path__ + "static/media/stove.510a5f24.png";